import React from 'react';
import { TickerDisplayData } from '../types/ticker';
import { TickerPerformanceData, formatPercent } from '../utils/performanceTabUtils';

export interface UsePerformanceTabStatisticsOptions {
  tickerPerformanceData: TickerPerformanceData;
  syncingTickers?: Set<string>;
  unsyncedTickers?: Set<string>;
  pollingLimitReached?: Set<string>;
}

export const formatPerformanceStatisticValue = (
  statisticKey: string,
  ticker: TickerDisplayData,
  options: UsePerformanceTabStatisticsOptions
): React.ReactNode => {
  const { tickerPerformanceData, syncingTickers, unsyncedTickers, pollingLimitReached } = options;
  const symbol = ticker.ticker;

  if (syncingTickers || unsyncedTickers || pollingLimitReached) {
    const isPollingLimitReached = pollingLimitReached?.has(symbol);
    if (isPollingLimitReached) {
      return <span className="text-gray-400 dark:text-text-secondary">-</span>;
    }
    const isSyncing = syncingTickers?.has(symbol);
    const isUnsynced = unsyncedTickers?.has(symbol);
    if (isSyncing || isUnsynced) {
      return <div className="animate-pulse bg-gray-200 dark:bg-border-color h-4 w-16 rounded"></div>;
    }
  }

  const row = tickerPerformanceData[symbol]?.performance;
  if (!row) {
    return <span className="text-gray-400 dark:text-text-secondary">-</span>;
  }

  const value = (row as any)[statisticKey] as number | null | undefined;
  if (value === null || value === undefined) {
    return <span className="text-gray-400 dark:text-text-secondary">-</span>;
  }

  const color = value > 0 ? 'text-market-green' : value < 0 ? 'text-market-red' : 'text-text-secondary';
  const sign = value > 0 ? '+' : '';
  return <span className={color}>{sign}{formatPercent(value)}</span>;
};

export const getPerformanceStatisticColor = (
  statisticKey: string,
  ticker: TickerDisplayData,
  options: UsePerformanceTabStatisticsOptions
): string => {
  const row = options.tickerPerformanceData[ticker.ticker]?.performance;
  if (!row) return 'text-gray-400 dark:text-text-secondary';
  const value = (row as any)[statisticKey] as number | null | undefined;
  if (value === null || value === undefined) return 'text-gray-400 dark:text-text-secondary';
  if (value > 0) return 'text-market-green';
  if (value < 0) return 'text-market-red';
  return 'text-text-secondary';
};

